import { render, staticRenderFns } from "./dev-page.vue?vue&type=template&id=a3b42930&scoped=true"
import script from "./dev-page.vue?vue&type=script&lang=js"
export * from "./dev-page.vue?vue&type=script&lang=js"
import style0 from "./dev-page.vue?vue&type=style&index=0&id=a3b42930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b42930",
  null
  
)

export default component.exports